import { UseDataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';
import { formatFilterIdsSearchParams } from '../../../modules/catalogs/products/catalogFilters.utils';
import { GetCatalogSectionsQueryParams } from './catalogs.queries.types';

export const getGetCatalogKey = (id: string, isOfflineMode = false): UseDataQueryKey => [
  'catalogs/:id',
  id,
  isOfflineMode,
];

export const getFindSuggestedCatalogsKey = (limit: number, brandId?: string): UseDataQueryKey => [
  'catalogs/suggested',
  brandId,
  { limit },
];

export const getGetCatalogSectionsKey = ({
  id,
  filters,
  customerIds,
  contextParams,
  groupParams,
}: GetCatalogSectionsQueryParams): UseDataQueryKey => [
  'catalogs/:id/products-count',
  id,
  {
    filters: formatFilterIdsSearchParams(filters, customerIds),
    customerIds,
    contextParams,
    groupParams,
  },
];

export const getFindDefaultCatalogKey = (): UseDataQueryKey => ['catalogs/default'];
